/**
 * A day header (§6.1, Board 2): *THU 22* on one line, the forecast or an
 * empty 14 px line under it — or nothing under it (`weather` null) in Day,
 * where the forecast is in the toolbar and *THU 22* sits centred (Board 12 A).
 */
import type { ReactNode } from 'react'
import { weekdayOf } from '@rowted/shared'
import { cn } from '../../lib/cn.js'

const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export function DayHead({ date, today, weather, selected = false }: {
  date: string; today: string; weather?: ReactNode | null
  /** The day ← → are on, when it is not today: its number ringed, as Outlook marks the selected day. */
  selected?: boolean
}) {
  const isToday = date === today
  const gone = date < today
  return (
    <div className="flex flex-col items-center gap-[5px]">
      <div className="flex items-center gap-1.5">
        <span className={cn('text-[10.5px] font-semibold uppercase tracking-[.05em]',
          isToday ? 'text-accent' : gone ? 'text-text-faint' : 'text-text-muted')}>
          {DAY_NAMES[weekdayOf(date)]}
        </span>
        {isToday ? (
          <b className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-accent text-[13px] text-white">
            {Number(date.slice(8))}
          </b>
        ) : selected ? (
          <b data-selected-day="" className="inline-flex h-6 min-w-6 items-center justify-center rounded-full border-[1.5px] border-accent px-1 text-[13px] text-accent-dark">
            {Number(date.slice(8))}
          </b>
        ) : (
          <b className={cn('text-[16px]', gone ? 'text-text-muted' : 'text-text')}>{Number(date.slice(8))}</b>
        )}
      </div>
      {weather === null ? null : weather ?? <span className="h-3.5" />}
    </div>
  )
}

